import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  iconActive?:string,
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
         this.collapseSidebar = window.innerWidth < 1024;
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }
  MENUITEMS: Menu[] = [
    // { path: "/dashboard", icon: "./assets/svg/dashboard.svg", title: "Dashboard",  active: false, type: "link", bookmark: true },
    { path: "/subscription", icon: "./assets/svg/subscription-list.svg", title: "Subscription List",  active: false, type: "link", bookmark: true },
    { path: "/transaction", icon: "./assets/svg/transaction.svg",iconActive: "./assets/svg/transaction-blue.svg", title: "Transaction",  active: false, type: "link", bookmark: true },
    // { path: "/subscription-plans", icon: "./assets/svg/subscription-plan.svg", title: "Subscription Plans",  active: false, type: "link", bookmark: true },
    { path: "/registration-List", icon: "./assets/svg/registration_list.svg", title: "Registration List",  active: false, type: "link", bookmark: true },
    { path: "/whatsapp-template", icon: "./assets/svg/whatsapp.svg", title: "Marketing Template",  active: false, type: "link", bookmark: true },
    { path: "/masters", icon: "./assets/svg/mastermenu.svg", title: "Masters",  active: false, type: "link", bookmark: true },
    { path: "/display-board-registration", icon: "./assets/svg/displayboardresistration.svg", title: "Display Board Registration",  active: false, type: "link", bookmark: true },
    { path: "/manage-users", icon: "./assets/svg/manage-users.svg", title: "WhatsApp User",  active: false, type: "link", bookmark: true },
    { path: "/monthly-expiring-subscriptions", icon: "./assets/svg/subscription-list.svg", title: "AMC Entry",  active: false, type: "link", bookmark: true },
    { path: "/messagify-user", icon: "./assets/svg/MessagifyUser.svg", title: "Messagify User",  active: false, type: "link", bookmark: true },
    { path: "/miniz-user-registration", icon: "./assets/svg/manage-users.svg", title: "Miniz User Registration",  active: false, type: "link", bookmark: true },
    { path: "/whatsapp-campaign", icon: "./assets/svg/whatsapp.svg", title: "Whatsapp Campaign",  active: false, type: "link", bookmark: true },
    { path: "/whatsapp-report", icon: "./assets/svg/whatsapp.svg", title: "Whatsapp Report",  active: false, type: "link", bookmark: true },
    { path: "/inbox", icon: "./assets/svg/whatsapp.svg", title: "Inbox",  active: false, type: "link", bookmark: true },
    // { path: "/send-notification", icon: "./assets/svg/send-notification.svg", title: "Send Notification",  active: false, type: "link", bookmark: true },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
